'use strict';

(function ($) {
    $.agito = $.agito || {};
    $.agito.hrmPage = $.agito.hrmPage || {};

    $.agito.hrmPage.wfAction = function (buttonId, instanceActivityTaskId, entityId, entityInstanceId, submitForm) {

        if (submitForm) {
            $('#ButtonPressed').val(buttonId);

            $.agito.hrmPage.submitForm(function () {
                window.location.href = window.location.href;
            });
        }
        else {
            // make transition without form submit

            var url = $.agito.baseUrl + 'Process/SubmitTask';

            $.post(url, {
                instanceActivityTaskId: instanceActivityTaskId,
                entityId: entityId,
                entityInstanceId: entityInstanceId,
                transitionId: buttonId,
            }, function (res) {
                window.location.href = window.location.href;
            });
        }
    }

    $.agito.hrmPage.buttonPressed = function (buttonId, successCallback) {
        // save button presseed information
        $('#ButtonPressed').val(buttonId);

        //var closeTab = false;
        //if ($.agito.userSettings) {
        //    closeTab = $.agito.userSettings.OpenInNewTab;
        //}

        if (buttonId === 'SAVEANDCLOSE') {
            $.agito.hrmPage.submitForm(function () {
                var history = UrlHelpers.PopHistory();
                if (history)
                    window.location = history.url;
            });
        } else if (buttonId === 'CLOSE') {
            var history = UrlHelpers.PopHistory();
            if (history)
                window.location.href = history.url;

        } else if (buttonId === 'REJECTTASK') {

            var placeholder = $.agito.hrmPage.createDialogPlaceholder();
            var $modal = $(placeholder);
            var $modalContent = $('.modal-content', $modal);

            $modalContent.empty();
            $modal.modal();
            var textArea = $('<textarea class="form-control" style="height:107px;"></textarea>');

            $modalContent.prepend($('<div class="modal-header"><button type="button" class="close" onclick="$.agito.dialogHelper.closeDialog($(this).closest(\'.modal\'))" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">' + $.agito.resources.getResource("WF_Reject_Head") + '</h4></div>'));
            $modalContent.append($('<div class="modal-body" style="padding-left:20px;padding-right:20px;min-width:670px;"></div>').append(textArea));

            var footer = $('<div class="modal-footer"><button type="button" class="btn btn-default btn-close" data-dismiss="modal" style="outline:none;">' + $.agito.resources.getResource("WF_Reject_Abort") + '</button></div>');
            footer.prepend($('<button type="button" class="btn btn-primary" data-dismiss="modal" style="outline:none;">' + $.agito.resources.getResource("WF_Reject_Confirm") + '</button>').click(function () {
                $('[data-basename="Workflow_Comment"]').find('input').val(textArea.val());
                $.agito.hrmPage.submitForm(successCallback, true);
            }));
            $modalContent.append(footer);

            return;
        } else {
            $.agito.hrmPage.submitForm(successCallback, true);
        }
    };

    /*
        Submits hrmPage form to action set in "$.agito.hrmPage.submitAction" or to default action if not set.

        On success: calls successCallback if set, otherwise reloads the form (not the page!)
    */
    $.agito.hrmPage.submitForm = function (successCallback, updateNavigationTitle, failCallback) {
        var $form = $('.hrm-page-body-placeholder form');

        var formValid = true;
        var formTableValues = {};

        // save iggrid tables
        $form.find('table.ui-iggrid-table').each(function () {
            var $this = $(this);

            if ($this.data('igGridUpdating')) {
                formValid = formValid && $this.igGridUpdating('findInvalid') === null;
                $this.igGridUpdating('endEdit', true, true);
            }

            // OBSOLETE: old form iggrids
            var $el = $(this).closest('.ag-form-table');

            if ($el.length === 0)
                return;

            var elementId = $el.attr('data-form-element-id');
            var getTableChangeset = $el.data('getTableChangeset');

            if (getTableChangeset) {
                var data = $el.data('getTableChangeset')();
                formTableValues[elementId] = data;
            }
        });

        $form.find('input[name="dynamicFormTables"]').val(JSON.stringify(formTableValues));

        // validate
        if (!formValid || !$form.valid())
            return;

        // save & reload
        // change submit action if defined so
        if ($.agito.hrmPage.submitAction)
            $form.attr('action', $.agito.hrmPage.submitAction);

        //var $messages = $('.hrm-page-messages-placeholder', $form.closest('.hrm-page-placeholder'));
        var $messages = $('.hrm-page-messages-placeholder');
        // save
        $.ajax({
            url: $form.attr('action'),
            type: 'POST',

            data: new FormData($form[0]),
            cache: false,
            contentType: false,
            processData: false,

            success: function (data) {

                if (data.success) {

                    var $placeholder = $('.hrm-page-placeholder');
                    var url = $placeholder.find('.hrm-page-body-placeholder').attr('data-current-url');
                    $form.attr('data-is-dirty', false);
                    $(window).trigger('ag.data.changed');

                    // replace current state in history (post save on create)
                    if ($placeholder.find('.hrm-page-body-placeholder').attr('data-is-new') === 'True') {

                        var el = document.createElement('a');
                        el.href = url;

                        var path = el.pathname;
                        var query = el.search;

                        if (path.length >= 'DynamicForm/Form'.length &&
                            path.substr(path.length - 'DynamicForm/Form'.length) === 'DynamicForm/Form') {
                            query = UrlHelpers.AddQueryParam(query, 'entityInstanceId', data.entityInstanceId);
                        } else {
                            path += '/' + data.entityInstanceId;
                        }

                        url = path + query;
                        if (!url.startsWith('/'))
                            url = '/' + url;

                        // replace current state in history
                        if ($.agito.hrmPage.updateHistory)
                            history.replaceState({}, '', url);
                    }

                    // call success callback or reload form
                    if (successCallback)
                        successCallback(data, url);
                    else
                        $.agito.hrmPage.activateForm(null, url, null, null, null, null);

                    // set new page title (in navigation)
                    if (updateNavigationTitle === true)
                        $('.globalnavigation-collapse-lg.globalnavigation-navigationbar-breadcrumb > a > span')
                            .text(data.entityInstanceTitle);

                    // show any messages
                    $.agito.hrmPage.handleAjaxError($messages, data, true);
                } else {
                    // show user messages
                    $.agito.hrmPage.handleAjaxError($messages, data, true);

                    if (failCallback)
                        failCallback(data);
                }
            }
        });
    };

    $.agito.hrmPage.onLeftNavigationClicked = function (formId, url, entityInstanceId, successHandler, requestReadOnly) {
        $(window).trigger('ag.form.unload', function (isDirty) {
            if (!isDirty)
                $.agito.hrmPage.activateForm(formId, url, entityInstanceId, successHandler, requestReadOnly, null);
        });
    }

    $.agito.hrmPage.activateForm = function (formId, url, entityInstanceId, successHandler, requestReadOnly, existingUserMessagesToShow) {


        // Load requested page
        if (!url)
            url = $.agito.baseUrl + 'DynamicForm/Form?formId=' + formId + '&entityInstanceId=' + entityInstanceId;

        // request readonly form
        if (requestReadOnly === true || requestReadOnly === false)
            url = UrlHelpers.AddQueryParam(url, 'requestReadOnly', requestReadOnly);

        // send currently active navigation menus to the next page
        var query = UrlHelpers.GetQuery(window.location.href);
        if (query.navigationId) {
            url = UrlHelpers.AddQueryParam(url, 'navigationId', query.navigationId);
        }

        // send current parameters to next page
        var jcParameter = $.agito.urlHelper.getParameterByName(url, '__jc');

        if ($('form.main-form input[name="Parameters"]').length > 0) {
            if (jcParameter === "") {
                url = UrlHelpers.AddQueryParam(url, '__jc', '{"Parameters": ' + $('form.main-form input[name="Parameters"]').val() + '}');
            }
            else {
                var jcParameters = JSON.parse(jcParameter);
                var parameters = JSON.parse($('form.main-form input[name="Parameters"]').val());

                if (jcParameters.parameters !== undefined) {
                    $.extend(jcParameters.parameters, parameters);
                }
                else {
                    jcParameters['Parameters'] = parameters;
                }

                url = UrlHelpers.AddQueryParam(url, '__jc', JSON.stringify(jcParameters));
            }
        }

        $('.hrm-page-placeholder')
            .load(url,
                function (r, s, x) {

                    if (AjaxHelpers.HandleExpiredSession(x)) {
                        $(this).hide();
                        return;
                    }

                    // remove first div (the repeated placeholder due to ajax ...)
                    $(this).children(':first').unwrap();

                    // record this action in history
                    if ($.agito.hrmPage.updateHistory) {
                        history.pushState({}, '', url);
                        document.title = $('.hrm-page-placeholder').find('.hrm-page-body-placeholder').attr('data-title');
                    }

                    // remove toolbar if set so
                    if (!$.agito.hrmPage.displayToolbar)
                        $('.hrm-page-placeholder .header').remove();

                    // display form
                    $('.hrm-page-placeholder').show();

                    if (typeof $.agito.hrmPage.activateFormGlobalSuccessHandler === 'function') {
                        $.agito.hrmPage.activateFormGlobalSuccessHandler();
                    }

                    if (typeof successHandler === 'function') {
                        successHandler();
                    }

                    // show user messages
                    if (existingUserMessagesToShow)
                        $.agito.hrmPage.handleAjaxError($('.hrm-page-messages-placeholder:first'), existingUserMessagesToShow, false);
                });
    };

    $.agito.hrmPage.handleAjaxError = function (target, ajaxResponse, clearTarget) {
        var vm = $(target).parent().data('viewModel');

        if (!vm)
            throw new Error("Unable to retrieve view model for given user messages target.");

        if (clearTarget !== false)
            vm.clear();

        var messages = ajaxResponse.userMessages || ajaxResponse;

        for (var item in messages) {
            if (messages.hasOwnProperty(item)) {
                if (messages[item].severity === 'Information') {
                    vm.addMessage(messages[item].message, 'info');
                } else if (messages[item].severity === 'Warning') {
                    vm.addMessage(messages[item].message, 'warn');
                } else if (messages[item].severity === 'Error') {
                    vm.addMessage(messages[item].message, 'error');

                    window.agTestContext = window.agTestContext || {};
                    window.agTestContext.lastError = messages[item].message;
                }
            }
        }
    }

    $.agito.hrmPage.quickEditDialog = function (entityId, entityInstanceId, parentEntityAttributeId, parentEntityInstanceId, successCallbackHandler, formGroupId, parameters, onFormLoaded) {
        // construct url
        var url = $.agito.baseUrl + 'DynamicForm/Dialog';
        url += '?entityId=' + (entityId || '');
        url += '&entityInstanceId=' + (entityInstanceId || '');
        url += '&parentEntityAttributeId=' + (parentEntityAttributeId || '');
        url += '&parentEntityInstanceId=' + (parentEntityInstanceId || '');
        url += '&formGroupId=' + (formGroupId || '');

        var data = null;
        if (parameters)
            data = { parameters: parameters };

        // open dialog
        $.agito.hrmPage.loadDialog(url, successCallbackHandler, onFormLoaded, data);
    }


    $.agito.hrmPage.openDeleteDialog = function (entityId, ids, entitiesToDelete, successHandler, conflictsHandler, formTableId, skipConfirmation, deleteFromDb) {

        // create dialog placeholder
        var placeholder = $.agito.hrmPage.createDialogPlaceholder();

        if (!skipConfirmation) {
            skipConfirmation = false;
        }

        var $modal = $(placeholder);
        var $modalContent = $('.modal-content', $modal);

        $modalContent.data('successHandler', successHandler);
        $modalContent.data('conflictsHandler', conflictsHandler);
        $modalContent.data('skipConfirmation', skipConfirmation);

        var deleteFromDb = (deleteFromDb === false || formTableId) ? false : true;

        var data = {
            entityId: entityId,
            ids: ids,
            formTableId: formTableId,
            entitiesToDelete: entitiesToDelete,
            deleteFromDb: deleteFromDb 
        };
        $.agito.dialogHelper.loadData(placeholder, $.agito.baseUrl + 'Application/Delete', null, null, data);
        
    }

    $.agito.hrmPage.openWizardSelectionDialog = function (parameters, direct) {

        var wizardIds = Object.keys(parameters);
        if (wizardIds.length === 0)
            return;

        //set history for SAVEANDCLOSE button
        //UrlHelpers.PushHistory(window.location.href);

        if (wizardIds.length === 1 && direct) {
            $.agito.hrmPage.createWizardInstance(wizardIds[0], parameters[wizardIds[0]]);
            return;
        }

        var placeholder = $.agito.hrmPage.createDialogPlaceholder();

        var $modal = $(placeholder);
        $modal.data('wizard-paramaters', parameters);

        var wizardIdsQuery = '';
        for (var index in wizardIds) {
            wizardIdsQuery += 'wizardIds[' + index + ']=' + wizardIds[index] + '&'
        }

        var url = $.agito.baseUrl + 'Wizard/LoadWizardSelectionDialog?' + wizardIdsQuery;
        $.agito.dialogHelper.loadData(placeholder, url);
    }

    $.agito.hrmPage.createWizardInstance = function (wizardId, parameters, handler) {

        var url = $.agito.baseUrl + 'Wizard/LoadWizardSelectionDialog';
        $.post(url, { wizardId: wizardId, parameters: parameters }, function (res) {
            if (typeof handler === 'function') {
                handler(res);
                return;
            }

            if (!res.success) {
                $.agito.hrmPage.handleAjaxError('.user-message-container', res);
                return;
            }

            UrlHelpers.PushHistory(window.location.href);
            UrlHelpers.OpenBrowserTab($.agito.baseUrl + 'Wizard/ExecuteStep?wizardInstanceId=' + res.entityInstanceId);
        });
    }

    $.agito.hrmPage.createDialogPlaceholder = function (customClass) {

        var $placeholder = $('<div class="modal ' + (customClass ? customClass : '') + '" tabindex="-1" role="dialog" data-backdrop="static"><div class="modal-dialog"><div class="modal-content"></div></div></div>');

        $placeholder.appendTo('body');
        $placeholder.uniqueId();

        return $placeholder;
    }

    $.agito.hrmPage.loadDialog = function (url, successCallbackHandler, loadCallback, data, customClass) {

        // create new div placeholder
        var placeholder = $.agito.hrmPage.createDialogPlaceholder(customClass);

        // set callback and open dialog
        placeholder.data('callback', successCallbackHandler);
        $.agito.dialogHelper.loadData(placeholder, url, loadCallback, null, data);
    }

    $.agito.hrmPage.submitDialog = function (buttonId) {

        var dialog = $(buttonId).closest('.modal');
        var formValid = true;
        var formTableValues = {};

        // save iggrid tables
        dialog.find('table.ui-iggrid-table').each(function () {
            var $this = $(this);

            if ($this.data('igGridUpdating')) {
                formValid = formValid && $this.igGridUpdating('findInvalid') === null;
                $this.igGridUpdating('endEdit', true, true);
            }

            var $el = $(this).closest('.ag-form-table');

            if ($el.length === 0)
                return;

            var elementId = $el.attr('data-form-element-id');
            var data = $el.data('getTableChangeset')();
            formTableValues[elementId] = data;
        });

        dialog.find('input[name="dynamicFormTables"]').val(JSON.stringify(formTableValues));

        // validate
        if (!formValid)
            return;

        $(buttonId).prop('disabled', true);

        // submit form and call callback function
        $.agito.dialogHelper.submitForm(dialog, false, dialog.data('callback'));
    }

    $.agito.hrmPage.Confirm = function (confirmMessageText, confirmHandler, rejectHandler) {

        // create dialog placeholder
        var placeholder = $.agito.hrmPage.createDialogPlaceholder();

        placeholder.data('confirmHandler', confirmHandler);
        placeholder.data('rejectHandler', rejectHandler);
        placeholder.data('confirmMessageText', confirmMessageText);

        $.agito.dialogHelper.loadData(placeholder, $.agito.baseUrl + 'Application/Confirm');
    }

    $.agito.hrmPage.CustomDialog = function (title, iconPath, message, buttons, buttonHandler) {

        // create dialog placeholder
        var placeholder = $.agito.hrmPage.createDialogPlaceholder();

        placeholder.data('buttonHandler', buttonHandler);
        placeholder.data('rejectHandler', null);

        var uriEncodedButtons = [];

        buttons.forEach(function (button) {
            var uriEncodedButton = {};

            if (button.ID != null)
                uriEncodedButton.ID = encodeURIComponent(button.ID);

            if (button.Text != null)
                uriEncodedButton.Text = encodeURIComponent(button.Text);

            if (button.IconPath != null)
                uriEncodedButton.IconPath = encodeURIComponent(button.IconPath);

            if (button.DismissColor != null)
                uriEncodedButton.DismissColor = button.DismissColor;

            uriEncodedButtons[uriEncodedButtons.length] = uriEncodedButton;
        });

        var url = $.agito.baseUrl + 'Application/CustomDialog?__jc='
        url += JSON.stringify({
            title: encodeURIComponent(title),
            message: encodeURIComponent(message),
            iconPath: encodeURIComponent(iconPath),
            buttons: uriEncodedButtons
        });


        $.agito.dialogHelper.loadData(placeholder, url);
    }

    /*
        Which submit action is to be used for form submit.
        If submit action is null, then default is used.
    */
    $.agito.hrmPage.submitAction = null;

    /*
        Before custom success handler is executed,
        execute global success handler. (optional)
    */
    $.agito.hrmPage.activateFormGlobalSuccessHandler = null;

    /*
        Indicates whether toolbar of loaded form(s) is to be displayed.
    */
    $.agito.hrmPage.displayToolbar = true;

    /*
        Indicates whether history will be updated with each click in navigation.
    */
    $.agito.hrmPage.updateHistory = true;

    $.agito.hrmPage.getSelectedEnterprise = function () {
        var $form = $('#globalnavigation-enterprise-info form');
        if (!$form)
            return null;

        var $field = $('#EnterpriseId', $form);
        if (!$field)
            return null;

        return $field.val();
    };

    $.agito.hrmPage.hideSection = function () {
        var $this = $(this);
        var section = $this.closest('.dynamic-form-section');
        var header = section.prev();
        header.find('.dynamic-form-section-header-text').text($this.text());

        section.addClass('ag-hidden');
        header.removeClass('ag-hidden');
    }

    $.agito.hrmPage.showSection = function () {
        var $this = $(this);
        var sectionHeader = $this.closest('.dynamic-form-section-header');
        var section = sectionHeader.next();

        sectionHeader.addClass('ag-hidden');
        section.removeClass('ag-hidden');

        section.trigger('shown');
    }

})($);

var Agitavit = Agitavit || {};
Agitavit.DynamicForm = Agitavit.DynamicForm || {};

Agitavit.DynamicForm.GenerateDocument = function ($form) {

    var entityId = $form.find('input[name="EntityId"]').val() || $form.data("___DO_NOT_USE___legacyAgForm").metadata.baseEntityId;
    var entityInstanceId = $form.find('input[name="EntityInstanceId"]').val() || $form.data("___DO_NOT_USE___legacyAgForm").entityInstanceId;

    $.agito.hrmPage.loadDialog($.agito.baseUrl + 'Administration/DocumentTemplates/SelectDocumentTemplateDialog?entityId=' + entityId + '&entityInstanceId=' + entityInstanceId);
}

Agitavit.DynamicForm.ShowHistory = function ($form) {

    var entityInstanceId = $form.find('input[name="EntityInstanceId"]').val() || $form.data("___DO_NOT_USE___legacyAgForm").entityInstanceId;
    var formId = $form.find('input[name="formId"],input[name="FormId"]').val() || $form.data("___DO_NOT_USE___legacyAgForm").metadata.formId;

    var url = $.agito.baseUrl + 'History/List?formId=' + formId + '&entityInstanceId=' + entityInstanceId;

    // dialog
    $.agito.hrmPage.loadDialog(url);
}

Agitavit.DynamicForm.EditForm = function ($form) {

    var formId = $form.find('input[name="formId"],input[name="FormId"]').val() || $form.data("___DO_NOT_USE___legacyAgForm").metadata.formId;
    var url = $.agito.baseUrl + 'Administration/Form/EditForm/' + formId;

    UrlHelpers.OpenBrowserTab(url, true);
}